<template>
  <div class="contents-container">
    <div class="sort-container">
      <sorting-menu type="posts"
                    v-if="posts.length !== 0 || currentSort === 'popularity'"
      />
    </div>
    <div v-if="posts">
      <div v-for="post in posts"
           :key="post.id"
      >
        <Post :post="post"
              :is-admin-page="true"
        />
      </div>
    </div>
    <infinite-loading :identifier="uniqueId"
                      @infinite="loadMorePosts"
                      ref="infiniteLoading"
    >
      <div slot="no-results">
        <div class="no-content" v-if="posts.length === 0 && loaded">
          <div>
            {{ $t('administrator.reportedContents.noReportedContents') }}
          </div>
          <logo-background />
        </div>
      </div>
      <div slot="no-more" />
    </infinite-loading>
  </div>
</template>

<script>
import LogoBackground from '@/components/shared/LogoBackground'
import Post from '@/components/post/Post'
import InfiniteLoading from 'vue-infinite-loading'
import SortingMenu from '@/components/shared/SortingMenu'

export default {
  name: 'ReportedContents',
  components: { LogoBackground, Post, InfiniteLoading, SortingMenu },
  data() {
    return {
      loaded: false
    }
  },
  async created() {
    await this.$store.dispatch('setPostFilter', 'reported')
    this.loaded = true
  },
  methods: {
    async loadMorePosts($state) {
      await this.$store.dispatch('fetchPosts')
      if ((this.$store.getters.cursors) && this.$store.getters.cursors.hasNext) {
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  },
  computed: {
    posts() {
      return this.$store.getters.filteredPosts
    },
    uniqueId() {
      // Unique identifier for infinite loading, reset state because we changed filters
      return this.$store.getters.postsFilter + new Date()
    },
    currentSort() {
      return this.$store.getters.postsSort
    }
  }
}
</script>
<style scoped lang="scss">

.contents-container {
  margin: 20px;
}

.sort-container {
  width: 606px;
  max-width: 100vw;
}

.posts {
  display: flex;
  flex-direction: column;
  width: 638px;
  min-height: 80vh;
}
</style>
